export const beforeItems: string[] = [
  'Starting every lesson plan from a blank page.',
  'Searching online minutes before class.',
  'Repeating the same activities too often.',
  'Managing disconnected files and resources.',
  'Struggling to adapt lessons for mixed abilities.',
  'Wondering what students should learn next.',
]

export const afterItems: string[] = [
  'Structured resources organized by level.',
  'Practical activities ready when you need them.',
  'Clear progression from foundational to advanced learning.',
  'Inclusive options built into the teaching process.',
  'Assessment and planning tools in one place.',
  'More confidence before every class.',
]

export const transformationStats: [string, string][] = [
  ['600+', 'PAGES READY TO TEACH'],
  ['180', 'STRUCTURED ACTIVITIES'],
  ['60', 'PAGES PER VOLUME'],
]
